import { useNavigate } from 'react-router-dom';

const useCheckAuth = level => {
  const navigate = useNavigate();
  const userLevel = localStorage.getItem('userLevel');

  if (level !== userLevel) {
    navigate('/');
    localStorage.clear();
    return false;
  }

  return true;
};

export default useCheckAuth;
